import { render, staticRenderFns } from "./MenuToggle.vue?vue&type=template&id=47dfa326&scoped=true&"
import script from "./MenuToggle.vue?vue&type=script&lang=js&"
export * from "./MenuToggle.vue?vue&type=script&lang=js&"
import style0 from "./MenuToggle.vue?vue&type=style&index=0&id=47dfa326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfa326",
  null
  
)

export default component.exports